import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import { Container } from '../Container/Container.jsx'
import Logos from '../Logos/Logos'
import Svg from "../../../src/assets/icons/icons.js"
import Search from "../../components/Search/Search";
import ToggleLanguage from "../ToggleLanguage/ToggleLanguage";
import PopupNew from '../../components/PopupNew/PopupNew.jsx'
import LogIn from '../LogIn/LogIn'
import OutsideClickHandler from 'react-outside-click-handler';
import { logout } from '../../store/auth/actions'
import i18n from "i18next";
import { withTranslation } from "react-i18next";
import { colors as c } from "../../styles/variables.js"
import { menuList } from "../../styles/variables";
import { Small, Medium } from "../../styles/typography/typography"
import {
    ContainerHeaderSt,
    HeaderSt,
    HeaderSecondRowSt,
    LogoSt,
    MobileBlockSt,
    BookmarkIconSt,
    ArrowSt,
    ToggleSt,
    NavSt,
    WrapperSt,
    LinkSt,
    DownloadLinkSt,
    CountBookmarkSt,
    AdditionalWrapSt,
    SiteListSt,
    MiddleListSt,
    BookmarkListSt,
    FavoritesWrapSt,
    UserListSt,
    UserNameSt,
    ItemSt,
    HeaderWrapperSt,
    LogosWrapSt,
    SecondLevelSt,
    SecondLevelItemSt,
    AccountIconSt,
    WrapSecondRow,

} from "./style";

const Header = ({ channelContent, _wholeSiteSearch }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [menuProfileIsOpen, setMenuProfileIsOpen] = useState(false);
    const [switchLangIsOpen, setSwitchLangIsOpen] = useState(false);
    const [searchBoxIsOpen, setSearchBoxIsOpen] = useState(false);
    const [popupIsOpen, setPopupIsOpen] = useState(false);

    const dispatch = useDispatch();
    const isLoggedIn = useSelector((store) => store.auth.isLoggedIn);
    const currentUser = useSelector((store) => store.auth.user);
    const favoritesCountRaw = useSelector((store) => store.favorites.count);
    const loadButtonText = useSelector((state) => state.channelContent.loadButtonText)

    const location = useLocation();

    // componentDidUpdate: закрываем поиск при переходе на другую страницу (кроме /search)
    const prevPathname = useRef(undefined);
    useEffect(() => {
        if (location.pathname !== prevPathname.current && location.pathname !== "/search") {
            setSearchBoxIsOpen(false);
        }
        prevPathname.current = location.pathname;
    }, [location.pathname]);

    const logOut = () => {
        setPopupIsOpen(false);
        dispatch(logout());
    };

    // попап с login/registration
    const handleOpenPopupClick = (e) => {
        e.preventDefault();
        setPopupIsOpen((prev) => !prev);
        setMenuIsOpen(false);
    };

    // открыть меню по кнопке бургер (моб версия)
    const handleOpenMenuClick = () => {
        setMenuIsOpen((prev) => !prev);
        setMenuProfileIsOpen(false);
    };

    // открыть меню профиля
    const handleOpenProfileMenuClick = (e) => {
        e.preventDefault()
        // тот же обработчик висит и на ссылке, и на родительском ItemSt:
        // без остановки всплытия переключение сработало бы дважды и меню не открылось бы
        e.stopPropagation()
        setMenuIsOpen(false);
        setSwitchLangIsOpen(false);
        setMenuProfileIsOpen((prev) => !prev);
        setSearchBoxIsOpen(false);
    };

    // открыть/закрыть меню с переключением языка
    const handleOpenSwitchLangClick = () => {
        setSwitchLangIsOpen((prev) => !prev);
        setMenuProfileIsOpen(false);
        setSearchBoxIsOpen(false);
    };

    // открыть/закрыть поисковую строку
    const handleOpenSearchBoxClick = () => {
        setSearchBoxIsOpen((prev) => !prev);
        setMenuProfileIsOpen(false);
        setMenuIsOpen(false);
    };

    const closeMenus = () => {
        setMenuIsOpen(false);
        setMenuProfileIsOpen(false);
    };

    const favoritesCount = favoritesCountRaw > 99 ? "99+" : favoritesCountRaw

    return (
        <>
            <ContainerHeaderSt>
                <Container>
                    <HeaderSt>
                        <HeaderWrapperSt>
                            {!(searchBoxIsOpen && (window.innerWidth < 768))
                                && <LogoSt
                                    to="/"
                                    onClick={closeMenus}>
                                    <img width={(window.innerWidth < 768) ? "43" : "57"} height={(window.innerWidth < 768) ? "40" : "52"} src={i18n.t(`header.logo`)} alt="" />
                                </LogoSt>
                            }
                            {(window.innerWidth < 768)
                                && (
                                    <MobileBlockSt>
                                        {isLoggedIn
                                            ?
                                            <>
                                                <AccountIconSt
                                                    className="account-icon"
                                                    onClick={(e) => handleOpenProfileMenuClick(e)}
                                                >
                                                    <Svg type="account_circle" />
                                                </AccountIconSt>

                                                <BookmarkIconSt
                                                    to={"/favorites"}
                                                    onClick={closeMenus} >
                                                    <Svg type="bookmark_border" />
                                                    {(isLoggedIn && favoritesCount)
                                                        ?
                                                        <CountBookmarkSt
                                                            className={searchBoxIsOpen ? "opacity" : ""}
                                                            style={{ right: '20px' }}>
                                                            <Small className="count" size="10px">{favoritesCount}</Small>
                                                        </CountBookmarkSt>
                                                        : null
                                                    }
                                                </BookmarkIconSt>
                                            </>
                                            :
                                            <AccountIconSt
                                                className="account-icon with-icon"
                                                onClick={(e) => handleOpenPopupClick(e)}
                                            >
                                                <NavLink to="/auth" >
                                                    <Svg type="login" />
                                                </NavLink>
                                            </AccountIconSt>

                                        }
                                        <Search
                                            className="search-header"
                                            isWrap={false}
                                            searchBoxIsOpen={searchBoxIsOpen}
                                            handleOpenSearchBoxClick={handleOpenSearchBoxClick}
                                            _wholeSiteSearch={(value) => _wholeSiteSearch(value)}
                                        />
                                    </MobileBlockSt>
                                )
                            }

                            <NavSt
                                className={window.innerWidth < 768 ? menuIsOpen ? "opened" : "closed" : ""}
                                left={menuIsOpen}
                            >
                                <ToggleSt
                                    onClick={(e) => handleOpenMenuClick(e)}
                                    className="toggle"
                                    aria-label="Открыть меню"
                                    type="button">
                                    <span className="visually-hidden">открыть меню</span>
                                </ToggleSt>
                                <WrapperSt className="wrapper">
                                    <AdditionalWrapSt>
                                        <SiteListSt className="site-list">
                                            {menuList.map((li, index) => (
                                                <ItemSt
                                                    key={index}
                                                    className="list-item"
                                                    onClick={(e) => (window.innerWidth < 768) && handleOpenMenuClick(e)}
                                                >
                                                    <LinkSt to={`${li.to}`} activeClassName="selected">
                                                        {i18n.t(`header.menuList.${index}.title`)}
                                                    </LinkSt>
                                                </ItemSt>
                                            ))}
                                            <BookmarkListSt className="bookmark-list">
                                                <ItemSt
                                                    className="list-item"
                                                    onClick={(e) => (window.innerWidth < 768) ? handleOpenMenuClick(e) : ""}>
                                                    <LinkSt
                                                        className="with-icon"
                                                        to={isLoggedIn ? "/favorites" : ((window.innerWidth < 768) ? "/auth" : "")}
                                                        onClick={(e) => (!isLoggedIn && (window.innerWidth > 768)) ? handleOpenPopupClick(e) : null}
                                                        activeClassName={isLoggedIn ? "selected" : ""} >
                                                        <Svg type="bookmark_border" />
                                                        <FavoritesWrapSt>
                                                            <Medium>{i18n.t(`header.favorites`)}</Medium>
                                                            {(isLoggedIn && favoritesCount)
                                                                ?
                                                                <CountBookmarkSt>
                                                                    <Small className="count not-hover" size="10px">{favoritesCount}</Small>
                                                                </CountBookmarkSt>
                                                                : null
                                                            }
                                                        </FavoritesWrapSt>
                                                    </LinkSt>
                                                </ItemSt>
                                            </BookmarkListSt>
                                            {(window.innerWidth < 768)
                                                ? ""
                                                : <>
                                                    <Search
                                                        className="search-header"
                                                        isWrap={false}
                                                        searchBoxIsOpen={searchBoxIsOpen}
                                                        handleOpenSearchBoxClick={handleOpenSearchBoxClick}
                                                        _wholeSiteSearch={(value) => _wholeSiteSearch(value)}
                                                    />
                                                </>
                                            }
                                        </SiteListSt>
                                        <MiddleListSt className="middle-list">
                                            <ItemSt className="list-item" onClick={(window.innerWidth < 768) ? handleOpenMenuClick : null}>
                                                {(i18n.language === "en") ?
                                                    <DownloadLinkSt className="with-icon" href="documents/catalogue_eng.pdf" download>
                                                        <Svg type="file_catalog" />
                                                        <Medium>{loadButtonText}</Medium>
                                                    </DownloadLinkSt>
                                                    :
                                                    <DownloadLinkSt className="with-icon" href="documents/catalogue_rus.pdf" download>
                                                        <Svg type="file_catalog" />
                                                        <Medium>{loadButtonText}</Medium>
                                                    </DownloadLinkSt>
                                                }
                                            </ItemSt>
                                        </MiddleListSt>
                                    </AdditionalWrapSt>
                                    <UserListSt
                                        className={menuProfileIsOpen && window.innerWidth < 768 ? "user-list user-list-opened" : "user-list"}>
                                        <ItemSt className="list-item"
                                            onClick={(e) => handleOpenProfileMenuClick(e)}
                                        >
                                            {((window.innerWidth > 768) && (window.innerHeight > 801)) && (isLoggedIn
                                                ? <LinkSt
                                                    className="with-icon user-list-account"
                                                    to="/"
                                                    onClick={(e) => handleOpenProfileMenuClick(e)}
                                                >
                                                    <Svg type="account_circle" />
                                                    <UserNameSt>{currentUser.full_name}</UserNameSt>
                                                    {window.innerWidth > 1260
                                                        && <ArrowSt className={menuProfileIsOpen ? "opened" : ""}> </ArrowSt>
                                                    }
                                                </LinkSt>
                                                :
                                                <LinkSt
                                                    onClick={(e) => handleOpenPopupClick(e)}
                                                    className="with-icon"
                                                    to="/auth">
                                                    <Svg type="login" />
                                                    <Medium>{i18n.t(`header.logIn`)}</Medium>
                                                </LinkSt>
                                            )}

                                            {(((window.innerHeight <= 800) && (window.innerWidth > 768)) || ((window.innerHeight === 1024) && (window.innerWidth === 768))) && (!isLoggedIn
                                                ?
                                                <LinkSt className="with-icon" to="/auth" >
                                                    <Svg type="login" />
                                                    <Medium>{i18n.t(`header.logIn`)}</Medium>
                                                </LinkSt>
                                                :
                                                <LinkSt
                                                    className="with-icon user-list-account"
                                                    to="/"
                                                    onClick={(e) => handleOpenProfileMenuClick(e)}
                                                >
                                                    <Svg type="account_circle" />
                                                    <UserNameSt>{currentUser.full_name}</UserNameSt>
                                                    {window.innerWidth > 1260
                                                        && <ArrowSt className={menuProfileIsOpen ? "opened" : ""}> </ArrowSt>
                                                    }
                                                </LinkSt>
                                            )}

                                            {(menuProfileIsOpen && isLoggedIn)
                                                && (
                                                    <OutsideClickHandler
                                                        onOutsideClick={() => { setMenuProfileIsOpen(false) }}
                                                    >
                                                        <SecondLevelSt className="profile-menu">
                                                            {window.innerWidth < 1260
                                                                && <SecondLevelItemSt className="profile-name"><Svg type="account_circle" /><Medium>{currentUser.full_name}</Medium></SecondLevelItemSt>
                                                            }
                                                            <SecondLevelItemSt
                                                                onClick={(e) => handleOpenProfileMenuClick(e)}
                                                            >
                                                                <LinkSt to="/profile"><Medium className="not-hover">{i18n.t(`header.profile`)}</Medium></LinkSt>
                                                            </SecondLevelItemSt>
                                                            <SecondLevelItemSt onClick={() => logOut()}>
                                                                <Medium>{i18n.t(`header.logOut`)}</Medium>
                                                            </SecondLevelItemSt>
                                                        </SecondLevelSt>
                                                    </OutsideClickHandler>
                                                )
                                            }
                                        </ItemSt>
                                    </UserListSt>
                                    <div style={{ position: 'absolute', paddingLeft: '0', right: '0' }}>
                                        <OutsideClickHandler onOutsideClick={() => { setSwitchLangIsOpen(false) }}>
                                            <ToggleLanguage
                                                switchLangIsOpen={switchLangIsOpen}
                                                handleOpenSwitchLangClick={handleOpenSwitchLangClick}
                                            />
                                        </OutsideClickHandler>
                                    </div>
                                </WrapperSt>
                            </NavSt>
                        </HeaderWrapperSt>
                    </HeaderSt>
                </Container>
            </ContainerHeaderSt>
            {
                (popupIsOpen && !isLoggedIn && window.innerWidth > 768)
                &&
                <PopupNew handleOpenPopupClick={handleOpenPopupClick}>
                    <LogIn viewType="popup" />
                </PopupNew>
            }
            {
                (((window.innerWidth > 768) && (location.pathname === "/catalog" || location.pathname.indexOf("/channel") !== -1))
                    ||
                    ((window.innerWidth > 768) && location.pathname.match(/catalog/)))
                &&
                <WrapSecondRow>
                    <HeaderSecondRowSt className={isLoggedIn ? "login" : ""}>
                        <LogosWrapSt>
                            <Logos
                                channelContent={channelContent}
                                productions={true}
                                container="header"
                                color={c.white}
                            />
                        </LogosWrapSt>
                    </HeaderSecondRowSt>
                </WrapSecondRow>
            }
        </>
    );
};

export default withTranslation()(Header);
